import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
} from '@mui/material';
import { LocationVm } from 'api/warehouse/location.vm';

interface AssignLocationToStationDialogProps {
  open: boolean;
  onClose: () => void;
  onAssign: (locationId: string) => void;
  warehouseId: string;
  loading?: boolean;
}

export function AssignLocationToStationDialog({ open, onClose, onAssign, warehouseId, loading }: AssignLocationToStationDialogProps) {
  const [locations, setLocations] = useState<LocationVm[]>([]);
  const [selected, setSelected] = useState('');
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (open && warehouseId) {
      setFetching(true);
      // Fetch locations for the warehouse
      import('api/warehouse/get-locations').then(({ getLocations }) => {
        getLocations(warehouseId, '', {
          success: (data) => {
            setLocations(data.objects || []);
            setFetching(false);
          },
          error: () => setFetching(false),
        });
      });
    }
  }, [open, warehouseId]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Atribuir Localização à Estação</DialogTitle>
      <DialogContent>
        {fetching ? (
          <CircularProgress />
        ) : (
          <FormControl fullWidth>
            <InputLabel id="location-select-label">Localização</InputLabel>
            <Select labelId="location-select-label" value={selected} label="Localização" onChange={(e) => setSelected(e.target.value)}>
              {locations.map((loc) => (
                <MenuItem key={loc.id} value={loc.id}>
                  {loc.id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={() => onAssign(selected)} disabled={!selected || loading} variant="contained">
          Atribuir
        </Button>
      </DialogActions>
    </Dialog>
  );
}
